var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09998 13.4C9.09998 12.9029 9.50292 12.5 9.99998 12.5H14C14.497 12.5 14.9 12.9029 14.9 13.4C14.9 13.897 14.497 14.3 14 14.3H9.99998C9.50292 14.3 9.09998 13.897 9.09998 13.4Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99998 3.09998C3.39835 3.09998 2.09998 4.39835 2.09998 5.99998V7.99998C2.09998 9.11346 3.02946 9.89998 4.09998 9.89998V18C4.09998 19.6016 5.39835 20.9 6.99998 20.9H17C18.6016 20.9 19.9 19.6016 19.9 18V9.89998C20.9705 9.89998 21.9 9.11346 21.9 7.99998V5.99998C21.9 4.39835 20.6016 3.09998 19 3.09998H4.99998ZM4.99998 4.89998C4.39246 4.89998 3.89998 5.39246 3.89998 5.99998V7.99998C3.89998 8.0552 3.94475 8.09998 3.99998 8.09998H20C20.0552 8.09998 20.1 8.0552 20.1 7.99998V5.99998C20.1 5.39246 19.6075 4.89998 19 4.89998H4.99998ZM6.99998 19.1C6.39246 19.1 5.89998 18.6075 5.89998 18V9.89998H18.1V18C18.1 18.6075 17.6075 19.1 17 19.1H6.99998Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 12.5C9.50292 12.5 9.09998 12.9029 9.09998 13.4C9.09998 13.897 9.50292 14.3 9.99998 14.3H14C14.497 14.3 14.9 13.897 14.9 13.4C14.9 12.9029 14.497 12.5 14 12.5H9.99998Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveOutline);
export default __webpack_public_path__ + "static/media/archive_outline.371f1a8657d13109ff2a5474533f841e.svg";
export { ForwardRef as ReactComponent };